/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";

import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  // renderAccessLocation2,
  renderLocationFunction
} from "../../../constant/helper/helper";
import Button from "../../../component/button/Button";
import SelectInput2 from "../../../component/input/SelectInput2";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import TextInput2 from "../../../component/input/TextInput2";
import RenderToolTip from "../../../component/tooltip/RenderToolTip";
import { toolTipData } from "./sheetStaticData";

const TopInput = ({
  values,
  loading,
  onSubmit,
  onChange,
  allLocations,
  currentUser
}) => {
  return (
    <div className="row">
      <RenderToolTip toolTipData={toolTipData} />
      <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <TextInput2
          data-tip
          type="date"
          name="fromDate"
          onChange={onChange}
          value={values.fromDate}
          data-for="fromDate"
          icon="mdi mdi-calendar-check"
          placeholder="Select From Date"
        />
      </div>
      <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <TextInput2
          data-tip
          type="date"
          name="toDate"
          onChange={onChange}
          value={values.toDate}
          data-for="toDate"
          icon="mdi mdi-calendar-check"
          placeholder="Select To Date"
        />
      </div>

      <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <SelectInput2
          data-tip
          name="locationId"
          isLabeled={true}
          onChange={onChange}
          icon="mdi mdi-map-marker-radius"
          data-for="locationName"
          label="Select Location"
          value={values.locationId}
          placeholder="Select Location"
        >
          {isSuperAdmin(currentUser)
            ? renderLocationFunction(allLocations)
            : renderAccessLocation2(
                locationRender(currentUser, false)
              )}
        </SelectInput2>
      </div>

      {loading ? (
        <div className="col-xl-1 col-lg-1 col-md-1 col-sm-1">
          <SpinnerButton />
        </div>
      ) : (
        <div className="col-xl-1 col-lg-1 col-md-1 col-sm-1">
          <div className="form-group">
            <Button
              type="button"
              onClick={onSubmit}
              title="GET"
              isBackgroundColor={false}
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn mb-2 text-white btn-dark btn-block"
            />
          </div>
        </div>
      )}
      <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <TextInput2
          data-tip
          type="text"
          name="Filter"
          data-for="Filter"
          onChange={onChange}
          value={values.Filter}
          icon="mdi mdi-magnify"
          placeholder="Search..."
        />
      </div>
    </div>
  );
};

TopInput.propTypes = {
  loading: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  allLocations: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired
};

export default TopInput;
